/* DA:
export const getConfigInstance = () => {
    return new Config(require(process.env.NODE_ENV === 'development' ? '../data/config_dev.json' : '../data/config.json'));
}

A:

*/
/**
 * Restituisce un json con la configurazione per le chiamate al backend,
 * es. {
 *   "host": "https://fpnet2.ericed.it",
 *   "backendFPNet": "/FPNet2021",
 *   "backendHR": "/FPNet2023",
 *   "backendDocs": "/Docs2022"
 * } * }
 */
export const getJSONConfiguration = () => {
    return require(process.env.NODE_ENV === 'development' ? '../data/config_dev.json' : '../data/config.json');
}
